module.exports = __webpack_public_path__ + "img/bob.32dcb5b8.jpg";